import Voteimage from "assets/img/votes.png";

import "./style.scss";
import { useAuth } from "context/AuthContext";

export function NoEvaluation() {
  const { currentStep } = useAuth();

  return (
    <>
      <div className="flex flex-col items-center justify-between mx-4 gap-9 md:flex-row md:mx-0">
        <div className="flex-1">
          <h2 className="mb-3 text-[31px] font-bold text-black-bb font-title">
            Prêmio BB: você não possui iniciativas para votar na {currentStep?.title}.
          </h2>
        </div>
        <div className="flex-1">
          <img
            width={"100%"}
            src={Voteimage}
            alt=""
            className="relative top-8"
          />
        </div>
      </div>
    </>
  );
}
